<!-- components/CookieModal.vue -->
<template>
  <div>
    <transition name="fade">
      <div v-if="!accepted" class="cookie-modal">
        <p class="mb-2">{{ $t('cookie.text') }}</p>
        <router-link to="/privacy" class="btn btn-sm btn-outline-primary me-2 mb-2">
          {{ $t('cookie.policy') }}
        </router-link>
        <button class="btn btn-sm btn-outline-primary mb-2" @click="acceptCookies">
          {{ $t('cookie.accept') }}
        </button>
      </div>
    </transition>

    <!-- Floating button -->
    <button v-if="accepted" class="cookie-btn floating-btn" @click="showInfo = true">
      <i class="fas fa-cookie-bite"></i>
    </button>

    <!-- Modal re-deschis -->
    <div v-if="showInfo" class="cookie-modal small">
      <p class="mb-2">{{ $t('cookie.text') }}</p>
      <router-link to="/privacy" class="btn btn-sm btn-outline-primary mb-2 me-2">
        {{ $t('cookie.policy') }}
      </router-link>
      <button class="btn btn-sm btn-outline-primary" @click="showInfo = false">
        {{ $t('cookie.close') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const accepted = ref(false)
const showInfo = ref(false)

onMounted(() => {
  accepted.value = localStorage.getItem('cookieAccepted') === 'true'
})

const acceptCookies = () => {
  localStorage.setItem('cookieAccepted', 'true')
  accepted.value = true
}
</script>

<style scoped>
.cookie-modal {
  position: fixed;
  bottom: 20px;
  left: 20px;
  max-width: 450px;
  padding: 1rem;
  font-family: 'Fira Code', monospace;
  background-color: #111;
  color: white;
  border: 2px solid #00ffcc;
  border-radius: 12px;
  box-shadow: 0 0 15px #00ffcc66;
  z-index: 999;
  animation: fadeIn 0.5s ease;
}

.cookie-modal.small {
  max-width: 500px;
  background-color: #000;
  box-shadow: 0 0 10px #00ffcc55;
    animation: popIn 0.2s ease-out 0.3s backwards;

}

.cookie-btn {
  bottom: 20px;
  left: 20px;
  background: linear-gradient(135deg, #00ffcc, #008f88);
  font-size: 20px;
    animation: popIn 1.2s ease-out 1.5s backwards;

}
.map-box {
  height: 100%;
  min-height: 300px;
  border: 2px solid #00ffcc;
  background-color: #111;
  box-shadow: 0 0 10px #00ffcc33;
  transition: box-shadow 0.3s ease;
}
.map-box:hover {
  box-shadow: 0 0 20px #00ffcc;
}

.custom-input {
  background-color: #222;
  border: 1px solid #00ffcc;
  color: white;
  font-family: 'Fira Code', monospace;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px transparent;
}

.custom-input:focus {
  border-color: #00ffcc;
  box-shadow: 0 0 8px #00ffccaa;
  background-color: #111;
}

.text-primary {
  color: #00ffcc !important;
}
.btn-outline-primary {
  position: relative;
  color: #00ffcc !important;
  border: 2px solid #00ffcc;
  background-color: transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 0 8px transparent;
}
input.custom-input,
textarea.custom-input {
  color: #fff !important;
}

.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary:disabled {
  color: #fff !important;
  border-color: #00a584;
  transform: translateY(-2px);
}
</style>
